import { render } from "./WebsiteManage.vue?vue&type=template&id=21496052&scoped=true"
import script from "./WebsiteManage.vue?vue&type=script&lang=js"
export * from "./WebsiteManage.vue?vue&type=script&lang=js"

import "./WebsiteManage.vue?vue&type=style&index=0&id=21496052&scoped=true&lang=css"

import exportComponent from "/Users/tandongling/Documents/vue/vue-argon-dashboard-2-pro-v3.0.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21496052"]])

export default __exports__